import { useCallback, useMemo, useSyncExternalStore } from 'react';

import {
  getIamportLoader,
  IamportCertificationParams,
  IamportPaymentParams,
} from '../utils/iamport-impl';

export const useIamport = () => {
  const iamportLoader = useMemo(() => getIamportLoader(), []);

  const { isLoading, isPending } = useSyncExternalStore(
    iamportLoader.subscribe,
    iamportLoader.getSnapshot,
  );

  const certificate = useCallback(
    (params: IamportCertificationParams) => {
      iamportLoader.execute(iamport => iamport.certificate(params));
    },
    [iamportLoader],
  );

  const pay = useCallback(
    (params: IamportPaymentParams) => {
      iamportLoader.execute(iamport => iamport.pay(params));
    },
    [iamportLoader],
  );

  return {
    isLoading,
    isPending,
    certificate,
    pay,
  };
};
